// The homepage toast, shared: one message at a time, bottom centre.
let timer;

export function toast(msg, ms = 3600) {
  const t = document.getElementById("toast");
  if (!t) return;
  t.textContent = msg;
  t.hidden = false;
  clearTimeout(timer);
  timer = setTimeout(() => { t.hidden = true; }, ms);
}
